<template>
  <main class="profile-page">
    <div class="profile-page__cover">
      <img :src="chat.profileCover" alt="Akan SMB" />
    </div>
    <!-- profile-page__cover -->

    <div class="profile-page__infos">
      <ProfilePhoto :images="chat.profilePhoto"></ProfilePhoto>

      <h1 class="profile-page__name">{{ chat.name }}</h1>
    </div>
    <!-- / profile-page__infos -->

    <router-link :to="getChatPageUrl(chat.id)" replace class="button">{{
      getLanguageCode($store.state.chats.chatLang) === "en"
        ? "Return to messages"
        : "Gå tilbake til meldinger"}}</router-link>
  </main>
</template>

<script>
import ProfilePhoto from "@/components/ProfilePhoto.vue";

export default {
  name: "Profile",
  components: {
    ProfilePhoto
  },
  data() {
    return {
      images: [require("@/assets/images/profile-photo-2.jpg")]
    };
  },
  methods: {
    getChatPageUrl(id) {
      const { token } = this.$route.query;
      let url = `/${
        this.$route.params.phone_number
      }${this.$store.getters.getChatPageUrl(id)}`;

      if (token) {
        url = `${url}?token=${token}`;
      }
      
      return url;
    },
    getFormattedChatName(chatName) {
      return this.$store.getters.getFormattedChatName(chatName);
    },
    getLanguageCode(language) {
      return language.slice(0, 2);
}
  },
  computed: {
    chatId() {
      return this.$route.params.id;
    },
    chat() {
      const chatId = this.chatId;
      return this.$store.getters.getChatById(chatId);
    }
  }
};
</script>

<style lang="scss">
.profile-page {
  max-width: $grid-max-width;
  position: relative;
  margin-right: auto;
  margin-left: auto;
  width: 100%;

  &__cover {
    border-radius: 0 0 50% 50% / 0 0 20% 20%;
    background-color: $color-primary;
    width: calc(100% + 40px);
    margin-left: -20px;
    position: relative;
    max-height: 320px;
    overflow: hidden;
    height: 70vh;

    @media #{$bigger-mobile} and (min-height: 720px) {
      max-height: 480px;
    }

    @media screen and (min-width: $grid-max-width) {
      margin-left: 0;
      width: 100%;
    }

    img {
      object-fit: cover;
      height: 100%;
      width: 100%;
    }
  }

  &__infos {
    padding-bottom: 100px;
    margin-top: -65px;

    .profile-thumbnail {
      margin: 0 auto 25px auto;
      height: 116px;
      width: 116px;
      z-index: 1;

      &--multiple {
        .profile-thumbnail__photo {
          box-shadow: 0px -5px 22px 0 rgba(0, 0, 0, 0.4);
          width: 80px;
          height: 80px;

          &:nth-of-type(even) {
            height: 75px;
            width: 75px;
          }
        }
      }
    }
  }

  &__name {
    font-family: $font-alt;
    letter-spacing: 0.6px;
    text-align: center;
    font-weight: 700;
    line-height: 1.3;
    font-size: 15px;
    padding: 0 15px;

    @media #{$bigger-mobile} {
      font-size: 18px;
    }
  }

  .button {
    transform: translateX(-50%);
    width: calc(100% - 30px);
    position: fixed;
    bottom: 15px;
    z-index: 10;
    left: 50%;
  }
}
</style>